<template>
	<div class="clearfix sort-item">
		<template v-for="(item, index) in ptInitData.uketoriServiceKbnList">
			<span v-if="item.UKETORI_SERVICE_KBN == 3 && ptInitData.productInfo.CONVENI_UKE_FLG == 1" :key="index"
				class="ConvenUke"><img src="../img/icons/convenience.gif" @error="getErrImage" width="25" height="25"
					:alt="$t('pt125.labels.convenienceStoreReceipt')"></span>
			<span v-else-if="item.UKETORI_SERVICE_KBN == 4 && ptInitData.productInfo.YUUBINKYOKU_UKE_FLG == 1"
				:key="index + 1" class="YuubinKyokuUke"><img src="../img/icons/jp_logo.gif" @error="getErrImage"
					width="25" height="25" :alt="$t('pt125.labels.postOfficeRecept')"></span>
			<span v-else-if="item.UKETORI_SERVICE_KBN == 5 && ptInitData.productInfo.HAKOPOST_UKE_FLG == 1"
				:key="index + 2" class="HakoPostUke"><img src="../img/icons/jp_hako_logo.gif" @error="getErrImage"
					width="25" height="25" :alt="$t('pt125.labels.happy')"></span>
		</template>
	</div>
</template>
<script> 
import common from "assets/js/common";
export default {
	name: 'clearfix',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	methods: {
		getErrImage(event) {
			common.getImgDefault(event);
		}
	}
}
</script>